import * as React from "react";
import { useAppContext } from "../../Contexts/AppContext";
import "./Info.scss";

export const InfoButton = ({ text }: { text: string }): JSX.Element => {
    const { setInfo } = useAppContext();

    return (
        <span className="info-button" onClick={(e) => setInfo({ text: text, xy: [e.clientX, e.clientY] })}>
            <span className="icon-conexus-question-circle"></span>
        </span>
    );
};
